/* easygusto Bottega : application du thème (un seul module, chargé en différé).
   - window.EG : panier Ajax (get, refresh, qty, add, addMany, setQty, clear, busy, paint), toast, sheet, closeSheet, money ;
   - événement « eg:cart » sur document (detail = panier Ajax) après chaque changement ;
   - délégation des clics : [data-add] [data-dec] [data-trio] [data-buynow] [data-sheet] [data-sheet-close]
     [data-search-open] [data-more] [data-scroll] [data-fav] [data-empty] [data-confirm-empty] [data-checkout] ;
   - en-tête en direct (#cn, #ct, #cg), classe .scrolled sur .hd, .has-bar sur .app, points de galerie ;
   - favoris maison : localStorage « eg-favs » ([{ id, handle }]), cœurs .heart[data-fav], compteurs [data-fav-count],
     événement « eg:favs » (detail = liste), page des favoris [data-eg-fav] (lignes eg-row par la Section Rendering API).
   Abonnements (16/10) : selling_plan (filtré comme une variante) passe par EG.add(vid, q, plan), EG.addMany et, sur la fiche
   produit, par le plan posé sur la racine [data-eg-abo-plan] (planFor) ; sans plan, rien ne change.
   Tout identifiant de variante est filtré (entier positif) avant /cart/add.js ; /cart/change.js ne reçoit que des clés de ligne
   (ou, à défaut, le rang de la ligne), jamais un identifiant de variante. Le client ne voit jamais d'erreur technique.
   Le balisage produit ici est identique à celui des snippets eg-qty (qtyHTML), eg-row (rowHTML) et eg-heart (heartHTML). */

const doc = document;
const CFG = (() => {
  try { return JSON.parse(doc.getElementById('eg-config').textContent); } catch (e) { return {}; }
})();
const T = CFG.t || {};
const ROOT = (() => {
  const r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || CFG.root || '/';
  return r.endsWith('/') ? r : r + '/';
})();
const FREE = CFG.free || 4900;
const REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const layer = doc.getElementById('layer') || doc.body.appendChild(Object.assign(doc.createElement('div'), { id: 'layer' }));

/* Icônes : relues dans le gabarit #eg-icons rendu par le snippet eg-icon (une seule source). */
const ICONS = {};
const iconTpl = doc.getElementById('eg-icons');
if (iconTpl) iconTpl.content.querySelectorAll('[data-i]').forEach((i) => { ICONS[i.dataset.i] = i.innerHTML.trim(); });
const icon = (n) => ICONS[n] || '';

function esc(s) {
  return String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

/* Prix au format français, identique au snippet eg-money : « 3,99 € » (espace insécable). */
/* Devise affichée autre que l'euro (marché en CHF…) : format de la langue de la page, jamais un « € » faux (audit L14).
   Le snippet eg-money suit la même règle (devise du panier autre que l'euro : filtre money de Shopify). */
const CUR = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
function money(cents) {
  let c = Math.round(Number(cents) || 0);
  const sign = c < 0 ? '−' : '';
  c = Math.abs(c);
  if (CUR !== 'EUR') {
    try { return sign + new Intl.NumberFormat(doc.documentElement.lang || 'fr', { style: 'currency', currency: CUR }).format(c / 100); } catch (e) { /* format euro ci-dessous */ }
  }
  return sign + Math.floor(c / 100) + ',' + String(c % 100).padStart(2, '0') + ' €';
}
const toCents = (v) => Math.round(parseFloat(v || 0) * 100);

/* ---------- Panier ---------- */
/* Quantités affichées par variante (counts, mises à jour tout de suite au clic) et lignes réelles du panier par variante
   (lineKeys : { key, line, quantity } dans l'ordre du panier, line = rang à partir de 1). Une même variante peut occuper
   plusieurs lignes (propriétés, remises automatiques) ; la clé d'une ligne change avec les remises appliquées.
   lineKeys suit chaque réponse du serveur, même pendant une action ; linesStale signale un ajout non encore relu. */
const counts = new Map();
const lineKeys = new Map();
let linesStale = false;
function setLines(items) {
  lineKeys.clear();
  (items || []).forEach((it, i) => {
    const k = String(it.variant_id);
    if (!lineKeys.has(k)) lineKeys.set(k, []);
    lineKeys.get(k).push({ key: String(it.key == null ? '' : it.key), line: i + 1, quantity: Math.max(0, Number(it.quantity) || 0) });
  });
  linesStale = false;
}
function setCounts(items) {
  counts.clear();
  (items || []).forEach((it) => { const k = String(it.variant_id); counts.set(k, (counts.get(k) || 0) + (Number(it.quantity) || 0)); });
}
{
  const first = (CFG.lines || []).map(([variant_id, quantity, key]) => ({ variant_id, quantity, key }));
  setLines(first);
  setCounts(first);
}
let cart = null;
let pending = 0;
let inflight = 0;
let chain = Promise.resolve();

function queue(fn) {
  inflight++;
  const p = chain.then(fn);
  chain = p.catch(() => {}).then(() => { inflight--; });
  return p;
}

/* Action sur le panier en cours (clic en attente ou requête dans la file). */
const busy = () => pending > 0 || inflight > 0;
/* Résout quand plus rien n'est en cours (ou après maxMs : le panier du serveur fait foi). */
function idle(maxMs) {
  const t0 = Date.now();
  return new Promise((resolve) => {
    (function wait() { if (!busy() || Date.now() - t0 > maxMs) resolve(); else setTimeout(wait, 60); })();
  });
}

/* Variantes dont la quantité maximale disponible est au panier : variante → quantité. Le « + » y est désactivé
   (audit P8 / B-C10). Rempli par le serveur (data-qty-max de eg-qty) ou par un refus 422 de /cart/add.js. */
const maxed = new Map();

async function api(path, body) {
  const opts = body === undefined
    ? { headers: { Accept: 'application/json' } }
    : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
  const r = await fetch(ROOT + path, opts);
  let j = null;
  try { j = await r.json(); } catch (e) { /* réponse vide */ }
  if (!r.ok) {
    /* Détail technique pour la console seulement : le client reçoit toujours un message générique (fail). */
    const err = new Error((j && (j.description || j.message)) || 'HTTP ' + r.status);
    err.status = r.status;
    err.path = path;
    err.description = (j && j.description) || ''; /* phrase de Shopify pour le client (422), jamais « Cart Error » */
    throw err;
  }
  /* Ajout accepté : les lignes connues (clés, quantités) sont à relire avant le prochain changement de quantité. */
  if (path.indexOf('cart/add') === 0) linesStale = true;
  return j;
}

/* Identifiant Shopify valide : entier positif, sinon chaîne vide. Sert aux variantes (/cart/add.js) et aux produits. */
function validId(v) {
  const s = String(v == null ? '' : v).trim();
  return /^[1-9]\d{0,15}$/.test(s) && Number.isSafeInteger(Number(s)) ? s : '';
}

/* Clé de ligne du panier (« 42384851140797:9a1b… », toujours une chaîne), sinon chaîne vide. Ne passe jamais par validId. */
function validKey(k) {
  const s = String(k == null ? '' : k).trim();
  return /^[1-9]\d{0,15}:[^\s"'<>]{1,200}$/.test(s) ? s : '';
}

/* Libellé traduit : réglage de #eg-config (T), sinon attribut data-l-* d'un cœur rendu par le serveur (snippet eg-heart). */
function lbl(key, attr) {
  if (T[key]) return T[key];
  const src = doc.querySelector('.heart[data-' + attr + ']');
  return (src && src.getAttribute('data-' + attr)) || '';
}

/* Message d'erreur : détail dans la console, phrase générique en français (ou allemand) pour le client. */
function fail(err, what, adding) {
  console.warn('[eg] ' + what, err);
  toast((adding && lbl('ajoutImpossible', 'l-err')) || T.erreur, null, true);
}

/* Enregistre le panier du serveur (lignes tout de suite) ; ne repeint qu'une fois toutes les actions en cours terminées. */
function commit(c) {
  cart = c;
  setLines(c.items);
  if (pending) return c;
  setCounts(c.items);
  paintAllQty();
  paintHeader(c);
  doc.dispatchEvent(new CustomEvent('eg:cart', { detail: c }));
  return c;
}

/* Relecture du panier impossible (réseau) : lignes à relire avant le prochain changement, nouvel essai dans 4 s
   (audit B-R02 : l'affichage ne reste pas sur un état jamais confirmé). */
let retryTimer = 0;
function settle() {
  if (pending) return Promise.resolve(cart);
  return queue(() => api('cart.js')).then(commit).catch((e) => {
    console.warn('[eg] panier non relu', e);
    linesStale = true;
    if (!retryTimer) retryTimer = setTimeout(() => { retryTimer = 0; settle(); }, 4000);
    return cart;
  });
}

/* Regroupe les quantités par variante (sans propriétés de ligne) avant l'envoi à /cart/add.js.
   Les identifiants vides ou non numériques sont écartés (cause de « expected Integer … : id »). */
function group(items) {
  const out = [];
  const byId = new Map();
  (items || []).forEach((i) => {
    const id = validId(i && i.id);
    if (!id) { console.warn('[eg] variante ignorée (identifiant invalide)', i); return; }
    const q = Math.floor(Number(i.quantity));
    const it = { ...i, id: Number(id), quantity: q > 0 ? q : 1 };
    /* Plan de vente (abonnement, 16/10) : identifiant entier positif, sinon retiré ; jamais regroupé avec un achat unique. */
    if (it.selling_plan != null && it.selling_plan !== '') {
      const sp = validId(it.selling_plan);
      if (sp) it.selling_plan = Number(sp);
      else { console.warn('[eg] plan de vente ignoré (identifiant invalide)', i); delete it.selling_plan; }
    } else delete it.selling_plan;
    if (it.properties || it.selling_plan) { out.push(it); return; }
    const prev = byId.get(it.id);
    if (prev) prev.quantity += it.quantity;
    else { byId.set(it.id, it); out.push(it); }
  });
  return out;
}

const linesOf = (vid) => lineKeys.get(String(vid)) || [];
const keep = (c) => { if (c && Array.isArray(c.items)) commit(c); };
const sumQ = (lines) => lines.reduce((n, l) => n + l.quantity, 0);

/* Change la quantité totale d'une variante, ligne par ligne. /cart/change.js reçoit la clé de la ligne (chaîne),
   ou son rang si la clé est absente : jamais l'identifiant de variante, qui ne désigne pas une ligne précise.
   Retrait par la dernière ligne d'abord. want(total) donne la quantité voulue d'après le total réellement au panier
   (total − 1 pour « − », valeur fixe pour setQty), ce qui reste juste après plusieurs clics rapides.
   Lignes relues sur /cart.js si elles sont inconnues ou périmées (après un ajout), puis une seconde fois si Shopify
   refuse (clé changée entre-temps, par exemple par une remise). La quantité voulue est fixée au premier calcul :
   si la réponse d'un changement déjà appliqué se perd, la seconde tentative ne retire pas une unité de plus.
   down : retrait seulement (« − »), jamais d'ajout même si le panier est déjà plus bas que prévu.
   À exécuter dans la file : aucun queue() ici. */
async function changeLines(vid, want, down) {
  let target = -1;
  for (let attempt = 0; ; attempt++) {
    try {
      if (attempt || linesStale || !linesOf(vid).length) keep(await api('cart.js'));
      let total = sumQ(linesOf(vid));
      if (target < 0) target = Math.max(0, Math.floor(want(total)) || 0);
      while (total > target) {
        const lines = linesOf(vid);
        const last = lines[lines.length - 1];
        const q = Math.max(0, last.quantity - (total - target));
        const key = validKey(last.key);
        keep(await api('cart/change.js', key ? { id: key, quantity: q } : { line: last.line, quantity: q }));
        const now = sumQ(linesOf(vid));
        if (now >= total) throw new Error('quantité inchangée par le serveur');
        total = now;
      }
      if (total < target && !down) await api('cart/add.js', { items: [{ id: Number(vid), quantity: target - total }] });
      return;
    } catch (e) {
      if (attempt) throw e;
      console.warn('[eg] panier relu avant une nouvelle tentative', e);
    }
  }
}

const EG = {
  get() { return cart ? Promise.resolve(cart) : EG.refresh(); },
  refresh() { return queue(() => api('cart.js')).then(commit); },
  qty(vid) { return counts.get(String(vid)) || 0; },
  /* plan (facultatif) : identifiant de plan de vente (abonnement), envoyé comme selling_plan. */
  add(vid, q = 1, plan) { return EG.addMany([plan ? { id: vid, quantity: q, selling_plan: plan } : { id: vid, quantity: q }]); },
  /* Ajout accepté mais panier non relu : la promesse est tenue quand même (sinon l'appelant, par exemple « Tout ajouter »
     d'une recette, reprendrait l'ajout produit par produit et doublerait le panier : audit J2). Quantités mises à jour
     d'après la demande, lignes relues au prochain changement. */
  addMany(items) {
    const list = group(items);
    if (!list.length) return Promise.reject(new Error('Aucune variante valide'));
    return queue(() => api('cart/add.js', { items: list }))
      .then((res) => EG.refresh().then(() => res, (e) => {
        console.warn('[eg] panier non relu après un ajout', e);
        list.forEach((it) => { const k = String(it.id); counts.set(k, EG.qty(k) + it.quantity); paintQty(k); });
        settle();
        return res;
      }));
  },
  /* Quantité totale voulue pour une variante (0 la retire) ; lignes changées par leur clé (changeLines).
     Changement accepté mais panier non relu : promesse tenue (même règle qu'addMany, audit J2 ; sinon le panier
     annonçait une erreur pour une ligne bel et bien retirée), quantité affichée d'après la demande, relecture par settle. */
  setQty(vid, q) {
    const id = validId(vid);
    if (!id) return Promise.reject(new Error('Variante invalide : ' + vid));
    const n = Math.max(0, Math.floor(Number(q)) || 0);
    pending++;
    return queue(() => changeLines(id, () => n))
      .finally(() => { pending--; })
      .then(() => EG.refresh().catch((e) => {
        console.warn('[eg] panier non relu après un changement de quantité', e);
        /* Autre clic en cours : ses quantités optimistes priment, settle repeindra à la fin. */
        if (!pending) { counts.set(id, n); paintQty(id); }
        settle();
        return cart;
      }), (e) => settle().then(() => { throw e; }));
  },
  clear() { return queue(() => api('cart/clear.js', {})).then(commit); },
  busy,
  /* Repeint les compteurs [data-qty-for] d'un fragment rechargé (section du panier) avec les quantités connues. */
  paint(root) { (root || doc).querySelectorAll('[data-qty-for]').forEach(paintWrap); },
  favs: null, /* rempli plus bas (Favoris maison) */
  validId, toast, sheet, closeSheet, money, paintSem
};
window.EG = EG;

/* Noms accessibles des boutons : ceux de l'enveloppe rendue par eg-qty (data-l-add1, data-l-dec, data-l-inc, avec le nom
   du produit : audit P15), sinon les libellés génériques de #eg-config. */
function qtyLabels(w) {
  const g = (a) => (w && w.getAttribute(a)) || '';
  return { add1: g('data-l-add1') || T.ajouterPanier, dec: g('data-l-dec') || T.retirerUn, inc: g('data-l-inc') || T.ajouterUn };
}

/* adder() de la maquette ; mode '' (.plus), 'big' (barre fixe) ou 'cta' (encadré d'achat). full : quantité maximale
   disponible au panier, « + » désactivé. La quantité est annoncée par la région live commune (say), pas par <output>. */
function qtyHTML(vid, q, mode, label, L, full) {
  L = L || qtyLabels(null);
  if (!q) {
    if (mode === 'big') return '<button class="big" data-add="' + vid + '">' + icon('plus').replace('<svg', '<svg width="20" height="20"') + esc(label) + '</button>';
    if (mode === 'cta') return '<button class="cta" data-add="' + vid + '">' + esc(label) + '</button>';
    return '<button class="plus" data-add="' + vid + '" aria-label="' + esc(L.add1) + '">' + icon('plus') + '</button>';
  }
  return '<span class="step"><button type="button" data-dec="' + vid + '" aria-label="' + esc(L.dec) + '">' + icon(q === 1 ? 'trash' : 'minus') +
    '</button><output>' + q + '</output><button data-add="' + vid + '" aria-label="' + esc(L.inc) + '"' + (full ? ' disabled' : '') + '>' + icon('plus') + '</button></span>';
}

function paintWrap(w) {
  const vid = w.dataset.qtyFor;
  const m = Number(w.getAttribute('data-qty-max'));
  if (m > 0 && !maxed.has(vid)) maxed.set(vid, m);
  const q = EG.qty(vid);
  const a = doc.activeElement;
  const had = a && w.contains(a) ? (a.hasAttribute('data-dec') ? 'dec' : 'add') : '';
  w.innerHTML = qtyHTML(vid, q, w.dataset.qtyMode || '', w.dataset.qtyLabel || '', qtyLabels(w), maxed.has(vid) && q >= maxed.get(vid));
  if (had) {
    /* « + » devenu inactif (quantité maximale) : le focus passe sur « − ». */
    const f = [w.querySelector(had === 'dec' ? '[data-dec]' : '[data-add]'), w.querySelector('[data-add]'), w.querySelector('[data-dec]')].find((x) => x && !x.disabled);
    if (f) f.focus({ preventScroll: true });
  }
}
function paintQty(vid) { doc.querySelectorAll('[data-qty-for="' + vid + '"]').forEach(paintWrap); }
function paintAllQty() { doc.querySelectorAll('[data-qty-for]').forEach(paintWrap); }

function paintHeader(c) {
  const cn = doc.getElementById('cn');
  const ct = doc.getElementById('ct');
  const cg = doc.getElementById('cg');
  if (cn) cn.textContent = c.item_count;
  if (ct) ct.textContent = money(c.total_price);
  if (cg) cg.style.width = Math.min(100, Math.round((c.total_price / FREE) * 100)) + '%';
}

/* Abonnement choisi sur la fiche produit (snippet eg-abo, sections/eg-product) : la racine [data-eg-abo-plan] porte le
   plan et la variante à laquelle il s'applique (data-eg-abo-v). Seuls les ajouts de cette variante, depuis cette racine,
   le reçoivent ; un autre produit de la page (« Parfait avec », rails) n'est jamais concerné. Sans plan : chaîne vide. */
function planFor(t, vid) {
  const r = t && t.closest ? t.closest('[data-eg-abo-plan]') : null;
  const id = validId(vid);
  if (!r || !id || validId(r.getAttribute('data-eg-abo-v')) !== id) return '';
  return validId(r.getAttribute('data-eg-abo-plan'));
}

/* Change la quantité d'une variante (delta +n / −n), avec affichage immédiat puis confirmation du serveur.
   opts.plan (ajout seulement) : plan de vente envoyé comme selling_plan (planFor). */
async function bump(vid, delta, opts = {}) {
  vid = validId(vid);
  if (!vid) { fail(new Error('identifiant de variante invalide'), 'panier', delta > 0); return; }
  const before = EG.qty(vid);
  const after = Math.max(0, before + delta);
  counts.set(vid, after);
  paintQty(vid);
  /* Nouvelle quantité annoncée une seule fois (audit X6) ; passage de 0 à 1 et retour à 0 : le message (toast) suffit. */
  if (before && after && !opts.silent) say(String(T.quantite || '__N__').replace('__N__', after));
  pending++;
  let refus = null;
  try {
    if (delta > 0) {
      const item = { id: Number(vid), quantity: delta };
      const sp = validId(opts.plan);
      if (sp) item.selling_plan = Number(sp);
      const res = await queue(() => api('cart/add.js', { items: [item] }));
      const it = res && res.items && res.items[0];
      if (!before && !opts.silent && it) {
        /* Lien « Voir mon panier → » (16/10) : sauf sur la page Panier elle-même. */
        const surPanier = CFG.cartUrl && location.pathname.replace(/\/$/, '') === String(CFG.cartUrl).replace(/\/$/, '');
        toast((T.ajoute || '__T__').replace('__T__', String(it.product_title || '').slice(0, 40)), null, false, 0,
          surPanier ? null : { href: CFG.cartUrl, label: T.voirPanier });
      }
    } else {
      /* Retrait : par la clé de ligne (changeLines), jamais par l'identifiant de variante. */
      await queue(() => changeLines(vid, (total) => total + delta, true));
      if (!after && !opts.silent) toast(T.retire, () => bump(vid, before, { silent: true }));
    }
  } catch (e) {
    /* Action refusée : l'affichage revient en arrière pour ce clic seulement (les autres clics en cours restent comptés). */
    counts.set(vid, Math.max(0, EG.qty(vid) - (after - before)));
    paintQty(vid);
    if (delta > 0 && e && e.status === 422) { refus = e; console.warn('[eg] quantité refusée par Shopify', e); }
    else fail(e, delta > 0 ? 'ajout au panier' : 'retrait du panier', delta > 0);
  } finally {
    pending--;
    await settle();
  }
  /* Refus de stock (422) : « + » désactivé à la quantité confirmée, et le vrai motif plutôt qu'« Impossible d'ajouter »
     (audit P8 / B-C10). Produit devenu indisponible (0 au panier) : message générique.
     Plafond posé seulement si la quantité est confirmée (aucun autre clic en cours : sinon « + » puis « − » rapides
     bloqueraient « + » une unité sous le vrai stock) et non nulle (sinon « + » resterait bloqué après un réassort). */
  if (refus) {
    const n = EG.qty(vid);
    if (n > 0 && !pending) maxed.set(vid, n);
    paintQty(vid);
    toast((n > 0 && (T.stockMax || refus.description)) || lbl('ajoutImpossible', 'l-err') || T.erreur, null, true);
  }
}

/* Plusieurs produits d'un geste (trio, recette, « Tout ajouter au panier ») : un envoi groupé ; s'il est refusé
   (une variante épuisée suffit), chaque produit est repris seul pour ajouter tout ce qui peut l'être.
   planOf (facultatif) : plan de vente d'une variante (planFor), sinon achat unique. */
async function addSeveral(raw, planOf) {
  const items = group(raw.map((id) => {
    const sp = planOf ? planOf(id) : '';
    return sp ? { id, quantity: 1, selling_plan: sp } : { id, quantity: 1 };
  }));
  if (!items.length) { fail(new Error('aucune variante valide : ' + raw.join(',')), 'ajout groupé', true); return; }
  items.forEach((it) => { const k = String(it.id); counts.set(k, EG.qty(k) + it.quantity); paintQty(k); });
  pending++;
  let ok = 0;
  try {
    try {
      await queue(() => api('cart/add.js', { items }));
      ok = items.reduce((n, it) => n + it.quantity, 0);
    } catch (e) {
      console.warn('[eg] ajout groupé refusé, reprise produit par produit', e);
      for (const it of items) {
        try { await queue(() => api('cart/add.js', { items: [it] })); ok += it.quantity; } catch (e2) {
          console.warn('[eg] variante non ajoutée ' + it.id, e2);
          const k = String(it.id);
          counts.set(k, Math.max(0, EG.qty(k) - it.quantity)); /* pas de quantité affichée qui n'a jamais été ajoutée */
          paintQty(k);
        }
      }
    }
    /* Singulier : « 1 produit ajouté au panier » (audit J9). */
    if (ok) toast(ok === 1 && T.trioUn ? T.trioUn : String(T.trio || '__N__').replace('__N__', ok));
    else fail(new Error('aucun produit ajouté'), 'ajout groupé', true);
  } finally {
    pending--;
    await settle();
  }
}

/* ---------- Message (toast), panneau bas (sheet), recherche ---------- */
let toastTimer;
/* Régions live permanentes (polie et alerte) : un message est annoncé une fois, même si le toast visible est remplacé
   ou recréé (audit X6). Le toast visible n'a donc pas de rôle live. */
const live = {};
function liveRegion(k) {
  let r = live[k];
  if (!r || !r.isConnected) {
    r = live[k] = doc.createElement('p');
    r.className = 'eg-sr';
    r.setAttribute('role', k);
    layer.appendChild(r);
  }
  return r;
}
/* Créées dès le chargement : une région ajoutée au moment du message n'est pas toujours annoncée. */
liveRegion('status');
liveRegion('alert');
function say(msg, isError) {
  if (!msg) return;
  const r = liveRegion(isError ? 'alert' : 'status');
  r.textContent = '';
  setTimeout(() => { r.textContent = msg; }, 60);
}

/* Dernière saisie au clavier (et pas à la souris ou au doigt) : un toast « Annuler » prend alors le focus. */
let kbd = false;
doc.addEventListener('keydown', (e) => { if (!e.ctrlKey && !e.metaKey && !e.altKey) kbd = true; }, true);
doc.addEventListener('pointerdown', () => { kbd = false; }, true);
/* Élément qui avait le focus avant qu'un toast « Annuler » ne le prenne : il le retrouve à la fermeture du toast. */
let toastBack = null;
let toastBackWrap = null;
/* Retour du focus : l'élément d'origine ; s'il a été redessiné, le premier bouton actif de son compteur [data-qty-for] ;
   s'il a disparu (ligne retirée, panier vidé), le titre de la page. */
function toastReturn() {
  const w = toastBackWrap && toastBackWrap.isConnected ? toastBackWrap.querySelector('button:not([disabled]), a[href]') : null;
  for (const t of [toastBack, w, doc.querySelector('#view h1[tabindex]'), doc.getElementById('view')]) {
    if (t && t.isConnected) { t.focus({ preventScroll: true }); if (doc.activeElement === t) return true; }
  }
  return false;
}
function toastRemove(d) {
  const had = d.contains(doc.activeElement);
  d.remove();
  if (had) { toastReturn(); toastBack = null; }
}

/* lien (facultatif, 16/10) : {href, label}, chemin du site seulement, affiché « label → » à droite du message (aide à la
   navigation : où retrouver ce qui vient d'être fait). Le toast reste alors 6000 ms.
   ms (facultatif) : durée d'affichage et délai après le survol. Sans lui : 6000 ms avec « Annuler », 4500 ms sinon.
   « Annuler » atteignable au clavier (audit P15) : après une action faite au clavier, le bouton reçoit le focus ; le toast
   reste alors affiché tant que le focus est dedans ; Tab ou Échap le rendent à l'élément d'origine. La fermeture
   suspendue par le survol ou le focus repart quand ils quittent le toast (audit J8). */
function toast(msg, undo, isError, ms, lien) {
  clearTimeout(toastTimer);
  layer.querySelectorAll('.toast').forEach(toastRemove);
  if (!msg) return;
  const d = doc.createElement('div');
  d.className = 'toast' + (isError ? ' toast-err' : '');
  const s = doc.createElement('span');
  s.textContent = msg;
  d.appendChild(s);
  let b = null;
  if (undo) {
    b = doc.createElement('button');
    b.type = 'button';
    b.setAttribute('data-undo', '');
    b.textContent = T.annuler || 'Annuler';
    b.addEventListener('click', () => { toastRemove(d); undo(); });
    d.appendChild(b);
  }
  const href = lien && typeof lien.href === 'string' && /^\/(?!\/)[A-Za-z0-9/._~%?=&-]*$/.test(lien.href) ? lien.href : '';
  if (href && lien.label) {
    const a = doc.createElement('a');
    a.className = 'toast-a';
    a.href = href;
    a.textContent = String(lien.label);
    const fl = doc.createElement('span');
    fl.setAttribute('aria-hidden', 'true');
    fl.textContent = ' →';
    a.appendChild(fl);
    d.appendChild(a);
  }
  layer.appendChild(d);
  say(msg, isError);
  const duree = Number(ms) > 0 ? Math.min(Number(ms), 60000) : (undo || href ? 6000 : 4500);
  const close = () => {
    /* Toast déjà retiré (focusout envoyé au retrait par certains navigateurs) : ne pas couper le minuteur du suivant. */
    if (!d.isConnected) return;
    clearTimeout(toastTimer);
    if (d.contains(doc.activeElement) || d.matches(':hover')) return;
    toastTimer = setTimeout(() => toastRemove(d), duree);
  };
  d.addEventListener('mouseenter', () => clearTimeout(toastTimer));
  d.addEventListener('mouseleave', close);
  d.addEventListener('focusin', () => clearTimeout(toastTimer));
  d.addEventListener('focusout', (e) => { if (!d.contains(e.relatedTarget)) setTimeout(close, 0); });
  /* stopPropagation : Échap ne ferme que le toast (pas la recherche ou le panneau ouverts dessous), et le piège de Tab
     de la boîte de dialogue ne déplace pas à nouveau le focus qui vient d'être rendu. */
  d.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); toastRemove(d); return; }
    if (e.key === 'Tab' && toastReturn()) { e.preventDefault(); e.stopPropagation(); }
  });
  const a = doc.activeElement;
  if (b && kbd && !(a && a.matches && a.matches('input, textarea, select, [contenteditable]'))) {
    toastBack = a && a !== doc.body ? a : null;
    toastBackWrap = toastBack && toastBack.closest ? toastBack.closest('[data-qty-for]') : null;
    b.focus({ preventScroll: true });
  }
  close();
}

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';
let lastFocus = null;

function openLayer(node, focusSel) {
  closeSheet(true);
  lastFocus = doc.activeElement;
  layer.appendChild(node);
  doc.documentElement.style.overflow = 'hidden';
  const f = (focusSel && node.querySelector(focusSel)) || node.querySelector(FOCUSABLE) || node.querySelector('[tabindex="-1"]');
  if (f) setTimeout(() => f.focus(), 30);
}

/* focusSel (facultatif) : élément qui reçoit le focus à l'ouverture (sinon le premier élément focalisable). */
function sheet(html, focusSel) {
  const bg = doc.createElement('div');
  bg.className = 'sheet-bg';
  bg.setAttribute('data-sheet-close', '');
  bg.innerHTML = '<div class="sheet" role="dialog" aria-modal="true" tabindex="-1">' + html + '</div>';
  /* Nom accessible du panneau : son premier titre en gras. */
  const title = bg.querySelector('.sheet b, .sheet h2, .sheet h3');
  if (title) {
    title.id = title.id || 'eg-sheet-t';
    bg.firstElementChild.setAttribute('aria-labelledby', title.id);
  }
  openLayer(bg, focusSel);
  return bg;
}

function closeSheet(silent) {
  const open = layer.querySelectorAll('.sheet-bg, .search');
  if (!open.length) return;
  open.forEach((n) => n.remove());
  doc.documentElement.style.overflow = '';
  if (!silent && lastFocus && lastFocus.isConnected) lastFocus.focus();
}

/* Recherche plein écran. Résultats rendus par le serveur (section eg-search-suggest : lignes eg-row, vraie variante, vrai
   stock, format et prix au kilo de eg-qline), sur /search/suggest par la Section Rendering API. suggest.json ne donne
   plus les variantes : construire les lignes ici déclarait tous les produits épuisés (audit B-C01, A-C6). rowHTML ne
   sert plus qu'en secours, si la section ne répond pas. */
const CERT = { 'cert-aop': 'AOP', 'cert-igp': 'IGP', 'cert-dop': 'DOP', 'cert-stg': 'STG', 'cert-doc': 'DOC', 'cert-docg': 'DOCG' };

/* Même règle que snippets/eg-name : format final retiré, puis le tiret qu'il laissait (« Pirro - (250 g) » → « Pirro »,
   audit B-C19), seulement quand un format a été retiré. */
function nm(title) {
  const t = String(title).replace(/[\u00a0\u202f]/g, ' ').replace(/\s*[–-]\s*Format.*$/, '').trim();
  const u = t.replace(/\s*\(\s*[\d.,\s]*\d[\d.,\s]*(kg|ml|cl|g|l)\s*\)\s*$/i, '').trim();
  return u === t ? u : u.replace(/\s*[–—‑-]+$/, '').trim();
}

/* Libellé avec le nom du produit (clé *_nom de #eg-config, « __X__ » = nom) ; sans elle, libellé générique seul. */
function avecNom(cle, generique, nom) {
  return T[cle] ? String(T[cle]).replace('__X__', () => String(nom || '')) : generique || '';
}

function brand(vendor) {
  const v = String(vendor || '').trim();
  return /^easygusto/i.test(v) ? esc(T.compose) : esc(v);
}

/* Format et prix au kilo ou au litre du secours de la recherche : même règle que snippets/eg-qline (audit A-P4, A-C6, B-C02,
   contre-vérification G2). Le format du titre décrit UNE unité ; « Pack de 6 », « Lot de 3 » (variante) ou « ×4 » (titre
   d'un produit sans variantes) le multiplient ; « ×N » ignoré si le format compte déjà les unités (« (6×33 cl) ») ;
   coffret de produits différents sans nombre d'unités : rien. Différence assumée avec le Liquid : ni prix unitaire Shopify
   ni poids ici (pas de garde-fou « ×4 » sur le poids expédié). */
function qparse(s) {
  let n = 1;
  s = s.trim();
  const mm = /^(\d+)\s*[×x]\s*(.+)$/.exec(s);
  if (mm) { n = +mm[1]; s = mm[2].trim(); }
  const m = /^([\d.,\s]*\d[\d.,\s]*?)\s*(kg|ml|cl|g|l)$/.exec(s);
  if (!m) return null;
  const x = parseFloat(m[1].replace(/\s/g, '').replace(',', '.'));
  if (!(x > 0)) return null;
  const u = m[2];
  return { n, base: u === 'kg' || u === 'l' ? x * 1000 : u === 'cl' ? x * 10 : x, ref: u === 'g' || u === 'kg' ? 'kg' : 'L' };
}
function qfmt(b, ref) {
  const r = (k, d) => (Number.isInteger(k) ? String(k) : String(Math.round(k * 10 ** d) / 10 ** d).replace('.', ','));
  if (ref === 'kg') return b < 1000 ? Math.round(b) + ' g' : r(b / 1000, 2) + ' kg';
  return b < 1000 ? r(b / 10, 1) + ' cl' : r(b / 1000, 2) + ' L';
}
/* vtitle : variante affichée ; multi : plusieurs variantes ; same : toutes au même prix ; coffret : type « Coffret Gourmand ». */
function qline(title, price, vtitle, multi, same, coffret) {
  const t = String(title).replace(/[\u00a0\u202f]/g, ' ').toLowerCase();
  const vt = String(vtitle || '').replace(/[\u00a0\u202f]/g, ' ').toLowerCase().trim();
  const w = t.split(/\s+/).filter(Boolean);
  const cands = multi ? [['v', vt]] : [];
  (t.match(/\(([^()]*)\)/g) || []).forEach((g) => cands.push(['t', g.slice(1, -1)]));
  [[w.slice(-1).join(' '), w[w.length - 2]], [w.length > 1 ? w.slice(-2).join(' ') : '', w[w.length - 3]]].forEach(([c, avant]) => {
    if (c && !(avant && /^[\d×x]+$/.test(avant) && /[×x]/.test(avant))) cands.push(['t', c]);
  });
  let f = null;
  let src = '';
  for (const [s, c] of cands) { f = qparse(c); if (f) { src = s; break; } }
  if (!f) return '';
  let n = f.n;
  if (multi && src === 't') {
    if (/unit/.test(vt)) { if (!/^1?$/.test(vt.replace(/unités|unité|unite|unit|×|x/g, '').trim())) return ''; }
    else if (/pack|lot|×/.test(vt) || (/x/.test(vt) && /\d/.test(vt))) {
      const k = vt.replace(/pack|lot|de|×|x/g, ' ').trim().split(/\s+/);
      if (k.length !== 1 || !/^\d+$/.test(k[0])) return '';
      n *= +k[0];
    } else if (!same) return '';
  }
  if (!multi && src === 't' && f.n === 1) { const k = w.find((x) => /^[×x]\d+$/.test(x)); if (k) n *= +k.slice(1); }
  if (coffret && n === 1 && src === 't') return '';
  const total = f.base * n;
  return (n > 1 ? qfmt(total, f.ref) + ' (' + n + ' × ' + qfmt(f.base, f.ref) + ')' : qfmt(total, f.ref)) + ' · ' + money(Math.round((price * 1000) / total)) + '/' + f.ref;
}

/* Boisson alcoolisée : même règle que snippets/eg-alcool (message sanitaire du secours de la recherche, audit A-P3). */
const ALC_T = /^(vins?( (rouges?|blancs?|rosés?))?|bières?|prosecco|lambrusco|grappa|gin|cocktails à base de vin)$/;
const MOTS_LOT = new Set(['bière', 'bières', 'biere', 'bieres', 'birra', 'birre', 'vin', 'vins', 'vino', 'vini', 'prosecco', 'lambrusco', 'spumante', 'limoncello', 'grappa', 'liqueur', 'liqueurs', 'spritz', 'gin', 'amaretto']);
function alcool(p) {
  const tags = (p.tags || []).map((x) => String(x).toLowerCase());
  const titre = String(p.title || '').toLowerCase();
  if (tags.includes('alcool')) return true;
  if (tags.includes('sans alcool') || tags.includes('sans-alcool') || titre.includes('sans alcool')) return false;
  const ty = String(p.type || '').toLowerCase().trim();
  if (ALC_T.test(ty) || /liqueur|spiritueux/.test(ty)) return true;
  if (String(p.body || '').toLowerCase().replace(/’/g, "'").includes("abus d'alcool")) return true;
  const lot = tags.includes('pack-produit') || tags.includes('pack-genere') || ty === 'coffret gourmand';
  return lot && titre.replace(/[—–\-×,()&'’]/g, ' ').split(/\s+/).some((m) => MOTS_LOT.has(m));
}

function badges(p, v) {
  let b = (p.tags || []).filter((tag) => CERT[tag]).map((tag) => '<span class="badge b-lab">' + CERT[tag] + '</span>').join('');
  const tags = p.tags || [];
  const save = toCents(v.compare_at_price) - toCents(v.price);
  if (tags.indexOf('pack-genere') >= 0 && save > 0) b += '<span class="badge b-pack">' + esc(T.moinsUnite).replace('__M__', money(save)) + '</span>';
  else if (tags.indexOf('volume-discount') >= 0) b += '<span class="badge b-vol">' + esc(T.remiseVolume) + '</span>';
  return b;
}

function sized(url, w) {
  if (!url) return '';
  return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
}

function rowHTML(p) {
  const vars = p.variants || [];
  const v = vars.find((x) => x.available) || vars[0] || { price: p.price, compare_at_price: p.compare_at_price_max, available: p.available };
  const vid = validId(v.id);
  const price = toCents(v.price != null ? v.price : p.price);
  const url = p.url;
  const img = (p.featured_image && p.featured_image.url) || p.image;
  let qty;
  /* Épuisé seulement si Shopify le dit ; variante inconnue (suggest.json sans variantes) : lien vers la fiche. */
  if (v.available === false || p.available === false) qty = '<button class="step eg-choose" disabled>' + esc(T.epuise) + '</button>';
  else if (vars.length > 1 || !vid) qty = '<a class="step eg-choose" href="' + esc(url) + '" aria-label="' + esc(avecNom('choisirNom', T.choisir, p.title)) + '">' + esc(T.choisir) + '</a>';
  else {
    /* Noms des boutons avec le produit, comme l'enveloppe de eg-qty (audit P15) ; deux-points de la langue (clés *_nom). */
    const L = { add1: avecNom('ajouterPanierNom', T.ajouterPanier, p.title), dec: avecNom('retirerUnNom', T.retirerUn, p.title), inc: avecNom('ajouterUnNom', T.ajouterUn, p.title) };
    qty = '<span data-qty-for="' + vid + '" data-qty-mode="" data-qty-label="" data-l-add1="' + esc(L.add1) + '" data-l-dec="' + esc(L.dec) + '" data-l-inc="' + esc(L.inc) + '">' + qtyHTML(vid, EG.qty(vid), '', '', L) + '</span>';
  }
  const varies = p.price_min != null && p.price_max != null && toCents(p.price_min) !== toCents(p.price_max);
  const priceTxt = varies ? String(T.des || '__P__').replace('__P__', money(toCents(p.price_min))) : money(price);
  const heart = heartHTML(p.id, p.handle, p.title);
  return '<div class="row" data-h="' + esc(p.handle) + '"><a class="ph" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
    (img ? '<img src="' + esc(sized(img, 176)) + '" alt="" width="88" height="88" loading="lazy">' : '') +
    '</a><div class="in"><a class="nm" href="' + esc(url) + '">' + esc(nm(p.title)) + '</a><span class="vd">' + brand(p.vendor) + '</span><span class="qt">' +
    qline(p.title, price, v.title, vars.length > 1, vars.every((x) => toCents(x.price) === toCents(v.price)), String(p.type || '').toLowerCase().trim() === 'coffret gourmand') +
    '</span><div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:2px">' + badges(p, v) + '</div>' +
    (alcool(p) ? '<p class="eg-alc" style="margin:2px 0 0;font-size:12px;line-height:1.3;color:var(--ink-2)">' + esc(T.alcool) + '</p>' : '') + '</div><div class="rt"><span class="pr">' + priceTxt + '</span>' + qty + heart + '</div></div>';
}

function openSearch() {
  const wrap = doc.createElement('div');
  wrap.className = 'search';
  wrap.setAttribute('data-search-close', '');
  wrap.innerHTML = '<div class="pane" role="dialog" aria-modal="true" aria-label="' + esc(T.recherche) + '"><form class="bar" action="' + esc(CFG.searchUrl || '/search') +
    '" method="get" role="search"><input id="q" name="q" type="search" placeholder="' + esc(T.recherchePh) + '" autocomplete="off" aria-label="' + esc(T.rechercheAria) +
    '"><input type="hidden" name="type" value="product"><button type="button" class="ibtn" data-search-close aria-label="' + esc(T.rechercheFermer) + '">' + icon('close') +
    '</button></form><p class="eg-sr" role="status" id="res-n"></p><div id="res" class="list"></div></div>';
  openLayer(wrap, '#q');
  const q = wrap.querySelector('#q');
  const res = wrap.querySelector('#res');
  const resN = wrap.querySelector('#res-n');
  /* Seul le nombre de résultats est annoncé, pas la liste entière à chaque frappe. */
  const announce = (n) => {
    resN.textContent = n === null ? '' : n === 1 ? (T.resUn || '1') : String(T.resN || '__N__').replace('__N__', n);
  };
  let timer;
  let ctrl;
  function chips() {
    const list = String(T.suggestions || '').split('|').filter(Boolean);
    res.innerHTML = list.length ? '<div class="chips" style="padding:0 0 8px;flex-wrap:wrap">' + list.map((x) => '<button type="button" class="chip" data-sugg="' + esc(x) + '">' + esc(x) + '</button>').join('') + '</div>' : '';
  }
  async function run() {
    const s = q.value.trim();
    if (s.length < 2) { if (ctrl) ctrl.abort(); chips(); announce(null); return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    const params = new URLSearchParams({
      q: s,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
    });
    const signal = ctrl.signal;
    try {
      let rows = null;
      try {
        const r = await fetch(ROOT + 'search/suggest?' + params.toString() + '&section_id=eg-search-suggest', { signal, headers: { Accept: 'text/html' } });
        const box = r.ok ? new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-eg-suggest]') : null;
        if (box) rows = Array.from(box.querySelectorAll('.row'));
      } catch (e) {
        if (e.name === 'AbortError') throw e;
        console.warn('[eg] suggestions du serveur indisponibles', e);
      }
      if (!rows) {
        const r = await fetch(ROOT + 'search/suggest.json?' + params.toString(), { signal, headers: { Accept: 'application/json' } });
        const j = await r.json();
        const hits = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        const t = doc.createElement('template');
        t.innerHTML = hits.map(rowHTML).join('');
        rows = Array.from(t.content.children);
      }
      announce(rows.length);
      const all = (CFG.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(s);
      res.innerHTML = rows.length
        ? '<div class="more"><a class="cta ghost" href="' + esc(all) + '">' + esc(T.voirTout) + '</a></div>'
        : '<div class="empty"><b>' + esc(String(T.aucunResultat || '__Q__').replace('__Q__', s)) + '</b><p>' + esc(T.aucunResultatTexte) + '</p><a class="cta" href="' +
          esc(CFG.collectionsUrl || '/collections') + '">' + esc(T.voirRayons) + '</a></div>';
      if (rows.length) {
        res.prepend(...rows);
        /* Quantités et cœurs à jour (clics en cours, favoris du navigateur). */
        res.querySelectorAll('[data-qty-for]').forEach(paintWrap);
        res.querySelectorAll('.heart[data-fav]').forEach(paintHeart);
      }
    } catch (e) {
      if (e.name !== 'AbortError') res.innerHTML = '<div class="empty"><p>' + esc(T.erreur) + '</p></div>';
    }
  }
  q.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
  wrap.addEventListener('click', (e) => {
    const s = e.target.closest('[data-sugg]');
    if (s) { q.value = s.dataset.sugg; run(); q.focus(); }
  });
  chips();
}

/* ---------- Favoris maison ----------
   Liste [{ id, handle }] (id produit) dans localStorage « eg-favs », lue et écrite sous try/catch : si le stockage est
   bloqué, les favoris tiennent le temps de la visite. Chaque changement repeint tous les cœurs du produit et les
   compteurs [data-fav-count] (masqués à 0), puis émet « eg:favs » sur document. Les autres onglets suivent (storage). */
const FAV_KEY = 'eg-favs';
/* Plafond de la liste : au-delà, l'ajout est refusé avec un message (aucun favori n'est évincé en silence). */
const FAV_MAX = 300;

function favClean(a) {
  const seen = new Set();
  const out = [];
  (Array.isArray(a) ? a : []).forEach((x) => {
    const id = validId(x && x.id);
    const handle = x && typeof x.handle === 'string' ? x.handle.trim() : '';
    if (!id || !handle || seen.has(id)) return;
    seen.add(id);
    out.push({ id, handle });
  });
  return out.slice(0, FAV_MAX); /* garde-fou contre un stockage trafiqué : l'interface refuse déjà tout ajout au-delà */
}
function favRead() {
  try { return favClean(JSON.parse(localStorage.getItem(FAV_KEY) || '[]')); } catch (e) { return []; }
}
let favs = favRead();

const favHas = (id) => favs.some((f) => f.id === String(id));

/* favSaved : faux si le navigateur a refusé l'écriture (stockage bloqué ou plein) : favoris de la visite seulement. */
let favSaved = true;
function favSet(list) {
  favs = favClean(list);
  try { localStorage.setItem(FAV_KEY, JSON.stringify(favs)); favSaved = true; } catch (e) { favSaved = false; }
  paintFav();
  doc.dispatchEvent(new CustomEvent('eg:favs', { detail: favs.slice() }));
}

/* Libellés « Ajouter aux favoris » / « Retirer des favoris » : ceux du cœur lui-même, sinon réglages traduits (T),
   sinon ceux d'un cœur rendu par eg-heart ; en dernier recours « Favori » (l'état reste porté par aria-pressed). */
function favLabel(on, b) {
  const own = b && b.getAttribute(on ? 'data-l-del' : 'data-l-add');
  return own || lbl(on ? 'favRetirer' : 'favAjouter', on ? 'l-del' : 'l-add') || T.favori || '';
}

/* heart() de la maquette, même balisage que le snippet eg-heart. Les attributs data-l-* ne sont posés qu'avec
   de vrais libellés traduits : un cœur créé ici ne devient jamais la source d'un libellé de repli. */
/* titre : nom fixe « Mettre en favori : … » (data-l-nom, comme eg-heart ; l'état est porté par aria-pressed seul). */
function heartHTML(id, handle, titre) {
  id = validId(id);
  if (!id || !handle) return '';
  const on = favHas(id);
  const nom = titre && T.favoriNom ? avecNom('favoriNom', '', titre) : '';
  const attrs = [['l-add', lbl('favAjouter', 'l-add')], ['l-del', lbl('favRetirer', 'l-del')], ['l-err', lbl('ajoutImpossible', 'l-err')], ['l-max', lbl('favLimite', 'l-max')], ['l-tmp', lbl('favTemp', 'l-tmp')], ['l-nom', nom]]
    .filter((a) => a[1]).map((a) => ' data-' + a[0] + '="' + esc(a[1]) + '"').join('');
  return '<button type="button" class="heart" data-fav="' + id + '" data-fav-handle="' + esc(handle) + '"' + attrs +
    ' aria-pressed="' + on + '" aria-label="' + esc(nom || favLabel(on)) + '">' + icon('heart') + '</button>';
}

/* data-l-nom (eg-heart) : nom fixe avec le produit (« Mettre en favori : … »), l'état est porté par aria-pressed seul
   (audit P15 et X « cœur au double sens »). Sans lui (cœur créé ici) : libellé qui suit l'état, comme avant. */
function paintHeart(b) {
  const on = favHas(b.dataset.fav);
  if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
  const l = b.getAttribute('data-l-nom') || favLabel(on, b);
  if (l && b.getAttribute('aria-label') !== l) b.setAttribute('aria-label', l);
}

/* « Ma semaine italienne » (16/10) : nombre de recettes de localStorage « eg-semaine » (écrit par eg-semaine.js) sur
   toutes les pages : liens [data-eg-sem-nav] (masqués à 0 s'ils portent data-eg-sem-masque), pastilles [data-eg-sem-n],
   textes [data-eg-sem-txt] (data-l-un, data-l-plus avec __N__), pastille de l'onglet Recettes. eg-semaine.js émet
   « eg:semaine » sur document à chaque changement ; les autres onglets suivent (storage). */
const SEM_MAX = 7;
function semN() {
  try {
    const o = JSON.parse(localStorage.getItem('eg-semaine') || 'null');
    if (!o || o.v !== 1 || !Array.isArray(o.r)) return 0;
    return Math.min(SEM_MAX, o.r.filter((e) => e && typeof e.h === 'string').length);
  } catch (e) { return 0; }
}
function paintSem() {
  const n = semN();
  doc.querySelectorAll('[data-eg-sem-nav][data-eg-sem-masque]').forEach((a) => { a.hidden = !n; });
  const tab = doc.querySelector('[data-tab="recettes"]');
  if (tab && !tab.querySelector('[data-eg-sem-n]') && n) {
    const dot = doc.createElement('span');
    dot.className = 'dot';
    dot.setAttribute('data-eg-sem-n', '');
    tab.appendChild(dot);
  }
  doc.querySelectorAll('[data-eg-sem-n]').forEach((el) => {
    const txt = n ? String(n) : '';
    if (el.textContent !== txt) el.textContent = txt;
    el.hidden = !n;
    el.style.display = n ? '' : 'none';
  });
  doc.querySelectorAll('[data-eg-sem-txt]').forEach((el) => {
    const m = n === 1 ? el.getAttribute('data-l-un') : String(el.getAttribute('data-l-plus') || '').replace('__N__', String(n));
    el.textContent = n ? (m || '') : '';
    el.hidden = !n;
  });
}
doc.addEventListener('eg:semaine', paintSem);
window.addEventListener('storage', (e) => { if (e.key === 'eg-semaine' || e.key === null) paintSem(); });
paintSem();

function paintFav() {
  doc.querySelectorAll('.heart[data-fav]').forEach(paintHeart);
  const n = favs.length;
  /* Onglet Favoris sans compteur dans son balisage : la pastille .dot de la maquette est ajoutée ici. */
  const tab = doc.querySelector('[data-tab="favoris"]');
  if (tab && !tab.querySelector('[data-fav-count]') && n) {
    const dot = doc.createElement('span');
    dot.className = 'dot';
    dot.setAttribute('data-fav-count', '');
    tab.appendChild(dot);
  }
  doc.querySelectorAll('[data-fav-count]').forEach((el) => {
    const txt = n ? String(n) : ''; /* vide à 0 : l'en-tête ordinateur recopie ce texte et se masque */
    if (el.textContent !== txt) el.textContent = txt;
    el.hidden = !n;
    el.style.display = n ? '' : 'none'; /* au cas où la feuille de style donne un display à l'élément */
  });
}

/* Dernier cœur basculé : la page Favoris s'en sert pour déplacer le focus quand sa ligne disparaît
   (Safari ne donne pas le focus à un bouton cliqué à la souris ou au doigt). */
let favLast = null;

function favToggle(b) {
  const id = validId(b.dataset.fav);
  const handle = String(b.dataset.favHandle || '').trim();
  if (!id) { console.warn('[eg] cœur sans identifiant produit', b); return; }
  const on = !favHas(id);
  if (on && !handle) { console.warn('[eg] cœur sans adresse produit', b); return; }
  if (on && favs.length >= FAV_MAX) { toast(lbl('favLimite', 'l-max') || T.erreur, null, true); return; }
  favLast = b;
  try { favSet(on ? favs.concat({ id, handle }) : favs.filter((f) => f.id !== id)); } finally { favLast = null; }
  /* Stockage refusé : on ne dit pas « ajouté » sans préciser que le favori ne tiendra que le temps de la visite (audit B-R03). */
  toast(on ? ((!favSaved && (b.getAttribute('data-l-tmp') || lbl('favTemp', 'l-tmp'))) || T.favAjoute) : T.favRetire);
}

EG.favs = {
  list: () => favs.slice(),
  has: favHas,
  add(id, handle) {
    id = validId(id);
    if (!id || !handle || favHas(id) || favs.length >= FAV_MAX) return false;
    favSet(favs.concat({ id, handle: String(handle) }));
    return true;
  },
  remove(id) { if (favHas(id)) favSet(favs.filter((f) => f.id !== String(id))); }
};

window.addEventListener('storage', (e) => {
  if (e.key !== FAV_KEY && e.key !== null) return;
  favs = favRead();
  paintFav();
  doc.dispatchEvent(new CustomEvent('eg:favs', { detail: favs.slice() }));
});

/* Page des favoris (section eg-page-favoris) : favView() de la maquette.
   Chaque ligne est demandée au serveur par la Section Rendering API sur l'adresse du produit
   (/products/<handle>?section_id=eg-page-favoris), qui ne rend que eg-row : même balisage que partout ailleurs.
   Produit supprimé ou dépublié (404, confirmé par /products/<handle>.js) : retiré des favoris.
   Erreur réseau : la ligne est sautée pour cette visite, le favori est gardé. */
function favPage(box) {
  const $ = (s) => box.querySelector(s);
  const list = $('[data-eg-fav-list]');
  const empty = $('[data-eg-fav-empty]');
  const off = $('[data-eg-fav-off]');
  const foot = $('[data-eg-fav-ft]');
  const all = $('[data-eg-fav-all]');
  const load = $('[data-eg-fav-load]');
  if (!list || !empty) return;
  const sid = box.dataset.section || 'eg-page-favoris';
  let run = 0;
  let tried = new Set();

  function syncAll() {
    if (!all) return;
    const ids = [];
    list.querySelectorAll('.row [data-qty-for]').forEach((w) => { const v = validId(w.dataset.qtyFor); if (v && ids.indexOf(v) < 0) ids.push(v); });
    all.setAttribute('data-trio', ids.join(','));
    all.hidden = !ids.length;
  }
  function show(el) {
    [list, empty, off].forEach((x) => { if (x) x.hidden = x !== el; });
    if (foot) foot.hidden = el !== list;
    if (load) load.hidden = true;
    box.removeAttribute('aria-busy');
    syncAll();
  }

  async function gone(handle) {
    try {
      const r = await fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
      return r.status === 404;
    } catch (e) { return false; }
  }
  async function fetchRow(f) {
    try {
      const r = await fetch(ROOT + 'products/' + encodeURIComponent(f.handle) + '?section_id=' + encodeURIComponent(sid), { headers: { Accept: 'text/html' } });
      if (r.status === 404) return { f, gone: await gone(f.handle) };
      if (!r.ok) return { f };
      const row = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('.row');
      return { f, row, gone: !row && (await gone(f.handle)) };
    } catch (e) {
      return { f };
    }
  }
  /* Lignes de plusieurs favoris en une requête : recherche « id:… OR id:… » rendue par la section eg-search
     (20 favoris par requête au lieu d'une requête par favori : audit J18). Un favori absent de la réponse (produit
     masqué de la recherche, épuisé masqué, supprimé…) repasse par son adresse produit (fetchRow). */
  async function fetchBatch(items) {
    const found = new Map();
    const chunks = [];
    for (let i = 0; i < items.length; i += 20) chunks.push(items.slice(i, i + 20));
    let k = 0;
    const worker = async () => {
      while (k < chunks.length) {
        const c = chunks[k++];
        try {
          const q = c.map((f) => 'id:' + f.id).join(' OR ');
          const r = await fetch(ROOT + 'search?' + new URLSearchParams({ q, type: 'product', section_id: 'eg-search' }).toString(), { headers: { Accept: 'text/html' } });
          if (!r.ok) continue;
          new DOMParser().parseFromString(await r.text(), 'text/html').querySelectorAll('.row').forEach((row) => {
            const h = row.querySelector('.heart[data-fav]');
            const id = h ? validId(h.dataset.fav) : '';
            /* Photos de la grille de recherche (240 px sur ordinateur) ramenées au format des lignes (88 px),
               comme le rendu par l'adresse produit : pas d'images plus lourdes sur la page des favoris. */
            row.querySelectorAll('img[sizes]').forEach((im) => im.setAttribute('sizes', '88px'));
            if (id && !found.has(id)) found.set(id, row);
          });
        } catch (e) { /* repli produit par produit */ }
      }
    };
    await Promise.all(Array.from({ length: Math.min(3, chunks.length) }, worker));
    return found;
  }
  /* Six requêtes à la fois au plus, résultats dans l'ordre des favoris. */
  async function fetchAll(items) {
    const out = new Array(items.length);
    let i = 0;
    const worker = async () => { while (i < items.length) { const k = i++; out[k] = await fetchRow(items[k]); } };
    await Promise.all(Array.from({ length: Math.min(6, items.length) }, worker));
    return out;
  }

  async function render() {
    const my = ++run;
    const items = favs.slice();
    tried = new Set(items.map((f) => f.id));
    if (!items.length) { list.innerHTML = ''; show(empty); return; }
    box.setAttribute('aria-busy', 'true');
    const pre = await fetchBatch(items);
    if (my !== run) return;
    const solo = await fetchAll(items.filter((f) => !pre.has(f.id)));
    if (my !== run) return;
    const byId = new Map(solo.map((x) => [x.f.id, x]));
    const res = items.map((f) => (pre.has(f.id) ? { f, row: pre.get(f.id) } : byId.get(f.id)));
    const frag = doc.createDocumentFragment();
    const drop = new Set();
    const next = [];
    let missed = 0;
    res.forEach(({ f, row, gone: g }) => {
      if (g) { drop.add(f.id); console.warn('[eg] favori retiré : produit introuvable « ' + f.handle + ' »'); return; }
      if (!row) { missed++; next.push(f); return; }
      /* Adresse du produit changée (redirection) : on garde la nouvelle. */
      next.push({ id: f.id, handle: row.getAttribute('data-h') || f.handle });
      row.setAttribute('data-fav-id', f.id);
      frag.appendChild(row);
    });
    list.innerHTML = '';
    list.appendChild(frag);
    list.querySelectorAll('[data-qty-for]').forEach(paintWrap);
    list.querySelectorAll('.heart[data-fav]').forEach(paintHeart);
    show(list.children.length ? list : missed ? off || empty : empty);
    const changed = drop.size || next.some((f) => favs.some((x) => x.id === f.id && x.handle !== f.handle));
    if (changed) favSet(favs.filter((f) => !drop.has(f.id)).map((f) => next.find((x) => x.id === f.id) || f));
  }

  /* Favori retiré (cœur de la ligne, autre onglet) : la ligne quitte la liste, comme dans favView() ; le focus passe
     au cœur de la ligne voisine. Favori ajouté ailleurs : la liste est reconstruite. */
  doc.addEventListener('eg:favs', () => {
    if (!box.isConnected) return;
    const ids = new Set(favs.map((f) => f.id));
    if (favs.some((f) => !tried.has(f.id))) { render(); return; }
    /* Liste vidée : « Aucun favori » seulement si plus aucun favori n'existe ; sinon (favoris non chargés) « indisponibles ». */
    const rest = () => (favs.length ? off || empty : empty);
    list.querySelectorAll('.row[data-fav-id]').forEach((row) => {
      if (ids.has(row.getAttribute('data-fav-id'))) return;
      if (row.contains(doc.activeElement) || (favLast && row.contains(favLast))) {
        const sib = row.nextElementSibling || row.previousElementSibling;
        row.remove();
        let target = sib && sib.querySelector('.heart');
        if (!list.children.length) { const r = rest(); show(r); target = r.querySelector('a, button'); }
        if (target) target.focus({ preventScroll: false });
        return;
      }
      row.remove();
    });
    if (!list.children.length && !list.hidden) show(rest());
    else syncAll();
  });

  render();
}

paintFav();
doc.querySelectorAll('[data-eg-fav]').forEach(favPage);

/* ---------- Délégation des clics ---------- */
const SEL = '[data-add],[data-dec],[data-trio],[data-buynow],[data-sheet],[data-sheet-close],[data-search-open],[data-search-close],[data-more],[data-scroll],[data-fav],[data-empty],[data-confirm-empty],[data-checkout],.search a';

doc.addEventListener('click', (e) => {
  const t = e.target.closest(SEL);
  if (!t) return;
  const d = t.dataset;
  if (t.matches('.search a')) { closeSheet(true); return; }
  if (d.searchClose !== undefined) { if (e.target === t || t.tagName === 'BUTTON') closeSheet(); return; }
  if (d.sheetClose !== undefined) {
    if (t.tagName === 'A') closeSheet(true); /* lien : on ferme et on laisse la navigation se faire */
    else if (e.target === t || t.tagName === 'BUTTON') { e.preventDefault(); closeSheet(); }
    return;
  }
  if (d.searchOpen !== undefined) { e.preventDefault(); openSearch(); return; }
  /* Attribut présent mais vide ou invalide : message générique, aucun appel au panier (validId dans bump, addSeveral). */
  if (d.add !== undefined) { e.preventDefault(); bump(d.add, 1, { plan: planFor(t, d.add) }); return; }
  if (d.dec !== undefined) { e.preventDefault(); bump(d.dec, -1); return; }
  if (d.trio !== undefined) {
    e.preventDefault();
    /* Double appui : un seul envoi à la fois (même garde que « Acheter maintenant »). */
    if (t.getAttribute('aria-busy') === 'true') return;
    t.setAttribute('aria-busy', 'true');
    addSeveral(d.trio.split(','), (id) => planFor(t, id)).finally(() => t.removeAttribute('aria-busy'));
    return;
  }
  if (d.buynow !== undefined) {
    e.preventDefault();
    const id = validId(d.buynow);
    if (!id) { fail(new Error('identifiant de variante invalide : ' + d.buynow), 'achat immédiat', true); return; }
    if (t.getAttribute('aria-busy') === 'true') return;
    t.setAttribute('aria-busy', 'true');
    pending++;
    const item = { id: Number(id), quantity: 1 };
    const sp = planFor(t, id);
    if (sp) item.selling_plan = Number(sp);
    queue(() => api('cart/add.js', { items: [item] }))
      .then(() => { location.href = CFG.cartUrl || ROOT + 'cart'; })
      .catch((err) => { t.removeAttribute('aria-busy'); fail(err, 'achat immédiat', true); })
      .finally(() => { pending--; settle(); });
    return;
  }
  if (d.sheet) {
    e.preventDefault();
    const tpl = doc.getElementById(d.sheet);
    if (tpl) sheet(tpl.innerHTML);
    return;
  }
  if (d.more !== undefined) {
    const el = doc.getElementById(d.more || 'desc');
    if (!el) return;
    el.classList.toggle('clamp');
    const clamped = el.classList.contains('clamp');
    t.textContent = clamped ? T.lireSuite : T.reduire;
    t.setAttribute('aria-expanded', String(!clamped));
    return;
  }
  if (d.scroll) {
    const el = doc.getElementById(d.scroll);
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
    return;
  }
  if (d.fav) { e.preventDefault(); favToggle(t); return; }
  if (d.empty !== undefined) {
    e.preventDefault();
    /* Focus initial sur « Garder mon panier » : Entrée par réflexe ne vide pas le panier (audit X, focus initial sur « Vider »). */
    sheet('<b>' + esc(T.viderTitre) + '</b><p style="margin:0;color:var(--ink-2)">' + esc(T.viderTexte) + '</p><button class="cta" data-confirm-empty>' + esc(T.viderOk) +
      '</button><button class="cta ghost" data-sheet-close>' + esc(T.viderGarder) + '</button>', 'button[data-sheet-close]');
    return;
  }
  if (d.confirmEmpty !== undefined) {
    e.preventDefault();
    closeSheet();
    EG.get().then((c) => {
      /* Abonnement éventuel gardé pour « Annuler » (audit B-R04). */
      const saved = (c.items || []).map((it) => {
        const o = { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
        const sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id;
        if (sp) o.selling_plan = sp;
        return o;
      });
      return EG.clear().then(() => toast(T.panierVide, () => EG.addMany(saved).catch((err) => fail(err, 'annulation du vidage', true))));
    }).catch((err) => fail(err, 'vidage du panier', false));
    return;
  }
  if (d.checkout !== undefined) {
    /* Paiement : bouton d'un formulaire (panier) → envoi du formulaire (note comprise), sinon /checkout. */
    const go = () => {
      const f = t.form;
      if (!f) { location.href = ROOT + 'checkout'; return; }
      if (f.requestSubmit) { f.requestSubmit(t); return; }
      const i = doc.createElement('input');
      i.type = 'hidden';
      i.name = t.name || 'checkout';
      f.appendChild(i);
      f.submit();
    };
    if (!busy()) { if (t.form) return; e.preventDefault(); go(); return; }
    /* Un ajout ou un retrait est en cours : on attend la fin de la file et la relecture du panier avant d'ouvrir le
       paiement, qui sinon peut partir avec l'ancien panier (audit P7 / B-R01). Au-delà de 10 s, le panier du serveur fait foi. */
    e.preventDefault();
    if (t.getAttribute('aria-busy') === 'true') return;
    t.setAttribute('aria-busy', 'true');
    idle(10000).then(() => EG.refresh()).catch(() => {}).then(() => { t.removeAttribute('aria-busy'); go(); });
  }
});

/* Clavier : Échap ferme le panneau ou la recherche ; Tab reste dans la boîte de dialogue ouverte. */
doc.addEventListener('keydown', (e) => {
  const open = layer.querySelector('.sheet-bg, .search');
  if (!open) return;
  if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
  if (e.key !== 'Tab') return;
  const f = Array.from(open.querySelectorAll(FOCUSABLE)).filter((x) => x.offsetParent !== null);
  if (!f.length) return;
  const first = f[0];
  const last = f[f.length - 1];
  if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
});

/* ---------- Défilement : .scrolled sur l'en-tête, points de galerie ---------- */
const hd = doc.getElementById('hd');
function onScroll() { if (hd) hd.classList.toggle('scrolled', window.scrollY > 4); }
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

doc.addEventListener('scroll', (e) => {
  const g = e.target;
  if (!g.classList || !g.classList.contains('gal-track')) return;
  const k = Math.round(g.scrollLeft / g.clientWidth);
  g.parentNode.querySelectorAll('.gal-dots span').forEach((dot, j) => dot.classList.toggle('on', j === k));
}, { capture: true, passive: true });

/* ---------- .has-bar quand une barre fixe (.pbar) est présente ---------- */
const app = doc.getElementById('app');
const view = doc.getElementById('view');
function syncBar() { if (app) app.classList.toggle('has-bar', !!(view && view.querySelector('.pbar'))); }
syncBar();
if (view && 'MutationObserver' in window) {
  let raf = 0;
  new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => { raf = 0; syncBar(); paintFav(); });
  }).observe(view, { childList: true, subtree: true });
}

/* Retour arrière depuis le cache du navigateur : le panier a pu changer ailleurs. */
window.addEventListener('pageshow', (e) => { if (e.persisted) EG.refresh().catch(() => {}); });
/* Autre onglet ou autre fenêtre : le panier a pu y changer. Lignes à relire avant le prochain « − » (sinon « − » peut
   augmenter la quantité ou en retirer plusieurs : audit P9) et panier relu au retour. */
doc.addEventListener('visibilitychange', () => {
  if (doc.visibilityState === 'hidden') linesStale = true;
  else EG.refresh().catch(() => {});
});
window.addEventListener('blur', () => { linesStale = true; });
window.addEventListener('focus', () => { if (linesStale && !busy()) EG.refresh().catch(() => {}); });

/* Éditeur de thème : section rechargée (page des favoris, lignes produit) → favoris, cœurs et compteurs relancés (audit J15). */
doc.addEventListener('shopify:section:load', (e) => {
  const sec = e.target;
  if (!sec || !sec.querySelectorAll) return;
  sec.querySelectorAll('[data-eg-fav]').forEach(favPage);
  sec.querySelectorAll('[data-qty-for]').forEach(paintWrap);
  paintFav();
});

/* ---------- Listes (eg-collection, eg-search) ----------
   « Voir plus » ajoute la page suivante par la Section Rendering API ; Espace active les pastilles-liens (role="button") ;
   les champs de prix vides ne sont pas envoyés. Sans JavaScript, tout reste en liens et formulaires standards. */
{
  const d = doc;
  /* Description repliée (« Lire la suite ») : un lien de la partie cachée qui reçoit le focus au clavier déplie le texte,
     sinon il serait atteint sans être visible (audit A-X10). Les liens déjà visibles restent atteignables comme avant. */
  d.addEventListener('focusin', (e) => {
    const el = e.target.closest && e.target.closest('.clamp[id]');
    if (!el || !e.target.closest('.eg-rte')) return;
    el.classList.remove('clamp');
    d.querySelectorAll('[data-more="' + el.id + '"]').forEach((b) => { b.textContent = T.reduire; b.setAttribute('aria-expanded', 'true'); });
  });
  d.addEventListener('keydown', (e) => {
    if (e.key !== ' ' || !e.target.closest) return;
    const a = e.target.closest('a[role="button"][href]');
    if (a) { e.preventDefault(); a.click(); }
  });
  d.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('form.eg-flt')) return;
    f.querySelectorAll('input[type="number"]').forEach((i) => { if (i.value === '') i.disabled = true; });
  });
  d.addEventListener('click', async (e) => {
    const a = e.target.closest && e.target.closest('a[data-eg-more]');
    const root = a && a.closest('[data-eg-list-root]');
    if (!root || !root.dataset.section) return;
    e.preventDefault();
    if (a.getAttribute('aria-busy') === 'true') return;
    a.setAttribute('aria-busy', 'true');
    try {
      const u = new URL(a.href, location.href);
      u.searchParams.set('section_id', root.dataset.section);
      const r = await fetch(u, { headers: { Accept: 'text/html' } });
      if (!r.ok) throw new Error(String(r.status));
      const html = new DOMParser().parseFromString(await r.text(), 'text/html');
      let first = null;
      html.querySelectorAll('[data-eg-append]').forEach((src) => {
        const dst = root.querySelector('[data-eg-append="' + src.dataset.egAppend + '"]');
        if (!dst || !src.firstElementChild) return;
        if (!first) first = src.firstElementChild;
        dst.append(...src.children);
        const hid = dst.closest('[hidden]');
        if (hid) hid.hidden = false;
      });
      const wrap = a.closest('[data-eg-more-wrap]');
      const next = html.querySelector('[data-eg-more-wrap]');
      if (next) wrap.replaceWith(next); else wrap.remove();
      const st = root.querySelector('[data-eg-more-status]');
      if (st) st.textContent = String(st.dataset.tpl || '').replace('__N__', root.querySelectorAll('[data-eg-append] > *').length);
      const f = first && first.querySelector('a:not([tabindex="-1"])');
      if (f) f.focus();
    } catch (err) {
      location.href = a.href;
    }
  });
}

doc.dispatchEvent(new CustomEvent('eg:ready', { detail: EG }));
